import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import { concat, differenceWith, filter, findIndex, flattenDeep, some, trim } from 'lodash';
import { message } from 'antd';
import { getDifferenceList, reOrderArray } from '../../lib/common';
import BrandTierWrap from '../../views/brand/tier/BrandTierWrap';
import { brandActions } from '../../store/modules/brand';
import { BRAND_TIER_SELECTOR_FILTER_OPTION_MODEL } from '../../store/modules/brand/models';
import { BRAND_TIER_LIST, BRAND_TIER_LIST_STATUS } from '../../constants/service/app/brandConstants';

class BrandTierContainer extends Component {
  componentDidMount() {
    const { getBrandTierInfo } = this.props;
    getBrandTierInfo({
      filterOption: BRAND_TIER_SELECTOR_FILTER_OPTION_MODEL,
    });
  }

  /**
   *
   * ****************************************
   *
   * 브랜드 티어 헤더에서 사용하는 액션들
   *
   * ****************************************
   */

  /**
   * 티어 일괄 변경
   */
  multipleTierChange = () => {
    const { brandTierHeader, brandTierList, setData } = this.props;
    const { selectedTier } = brandTierHeader;
    const { selectedList } = brandTierList;

    /**
     * 티어를 변경할 브랜드 리스트가 undefined 이거나 변경할 티어와 같은 티어인 브랜드들이 아닌 경우
     * 1차원 배열 형태로 변환해준다.
     */
    const flattenSelectedList = filter(
      flattenDeep(selectedList),
      (item) => item !== undefined && item.tier !== selectedTier,
    );

    /**
     *  브랜드 티어 변경
     */
    if (flattenSelectedList.length) this.changeTierOnBrandTierList(selectedTier, flattenSelectedList);

    /**
     *  선택했었던 브랜드 리스트 초기화
     */
    setData({
      path: ['brandTierList', 'selectedList'],
      value: [],
    });
  };

  /**
   * 저장하기 버튼 활성/비활성 여부 체크
   */
  checkIsModified = () => {
    const { brandTierList } = this.props;
    const { newList } = brandTierList;

    let isModified = false;
    some(newList, (tierList) => {
      some(tierList, (item) => {
        if (item.listStatus === BRAND_TIER_LIST_STATUS.MODIFIED) {
          isModified = true;
          return isModified;
        } else if (item.listStatus === BRAND_TIER_LIST_STATUS.ADDED) {
          isModified = true;
          return isModified;
        } else if (item.listStatus === BRAND_TIER_LIST_STATUS.DELETED) {
          isModified = true;
          return isModified;
        }
      });
      return isModified;
    });

    return isModified;
  };

  /**
   * 초기화
   */
  resetBrandTierInfo = () => {
    const { brandTierList, setData } = this.props;
    const { originList } = brandTierList;

    /**
     *  헤더의 선택 티어 초기화
     */
    setData({
      path: ['brandTierHeader', 'selectedTier'],
      value: null,
    });

    /**
     *  브랜드 티어 패널 토글 초기화
     */
    setData({
      path: ['brandTierList', 'toggleList'],
      value: [true, true, true, true, true],
    });

    /**
     *  브랜드 티어 리스트 초기화
     */
    setData({
      path: ['brandTierList', 'newList'],
      value: originList.map((tierList) =>
        tierList.map((item) => ({
          ...item,
          listStatus: BRAND_TIER_LIST_STATUS.NORMAL,
        })),
      ),
    });

    /**
     *  브랜드 티어 리스트 선택값 초기화
     */
    setData({
      path: ['brandTierList', 'selectedList'],
      value: [],
    });

    /**
     *  브랜드 셀렉터 선택 티어 값 초기화
     */
    setData({
      path: ['brandTierSelector', 'selectedTier'],
      value: null,
    });

    /**
     *  브랜드 셀렉터 선택값 초기화
     */
    setData({
      path: ['brandTierSelector', 'selectedList'],
      value: [],
    });
  };

  /**
   * ****************************************
   *
   * 브랜드 티어 리스트에서 사용하는 액션들
   *
   * ****************************************
   */

  /**
   * 리스트 브랜드 선택
   */
  selectBrandTierItem = (item) => {
    const { brandTierList, setData } = this.props;
    const { selectedList } = brandTierList;

    /**
     *  선택한 브랜드의 티어
     */
    const tier = item.tier;
    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = tier - 1;
    /**
     *  선택한 티어에서 이미 선택된 브랜드 리스트
     */
    const selectedListOnTier = selectedList[tierIndex] ? selectedList[tierIndex] : [];

    /**
     *  선택한 티어에서 이미 선택된 브랜드 리스트와 추가된 브랜드를 합쳐서 새로운 배열로 덮어쓴다.
     */
    setData({
      path: ['brandTierList', 'selectedList', tierIndex],
      value: [...selectedListOnTier, item],
    });
  };

  /**
   * 리스트 브랜드 전체 선택
   */
  selectBrandTierList = (tier) => {
    const { brandTierList, setData } = this.props;
    const { newList, selectedList } = brandTierList;

    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = tier - 1;
    /**
     *  선택한 티어의 리스트
     */
    const tierList = newList[tierIndex];
    /**
     *  이미 선택된 브랜드 리스트
     */
    const selectedListOnTier = selectedList[tierIndex] ? selectedList[tierIndex] : [];

    /**
     *  선택한 브랜드 리스트와 이미 등록된 브랜드 리스트를 비교해서 이미 등록되지 않은 것들만 등록
     */
    const newSelectedList = getDifferenceList(tierList, selectedListOnTier, 'storeId', 'storeId');

    /**
     *  이미 등록된 브랜드 리스트 + 선택한 브랜드 리스트
     */
    setData({
      path: ['brandTierList', 'selectedList', tierIndex],
      value: [...selectedListOnTier, ...newSelectedList],
    });
  };

  /**
   * 리스트 브랜드 선택해제
   */
  deselectBrandTierItem = (data) => {
    const { brandTierList, setData } = this.props;
    const { selectedList } = brandTierList;
    const { storeId, tier } = data;

    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = tier - 1;
    /**
     *  선택한 티어에서 이미 선택된 브랜드 리스트
     */
    const selectedListOnTier = selectedList[tierIndex] ? selectedList[tierIndex] : [];
    /**
     *  선택된 브랜드 목록에서 storeId 를 기준으로 요소 삭제
     */
    const deletedList = filter(selectedListOnTier, (item) => item.storeId !== storeId);

    /**
     *  selectedList 에 해당 브랜드 삭제
     */
    setData({
      path: ['brandTierList', 'selectedList', tierIndex],
      value: deletedList,
    });
  };

  /**
   * 스크롤 이동
   */
  scrollToBrandElement = (tier, no) => {
    /**
     *  티어 목록 내부에서 스크롤 이동, 전체 스크롤 이동 이후 동작
     */
    setTimeout(() => {
      return scroller.scrollTo(`tier_${tier}_no_${no}`, {
        duration: 100,
        smooth: true,
        containerId: `brand-tier-list-scroll_${tier}`,
        offset: -650,
      });
    }, 1000);
  };

  /**
   * 브랜드 상태에 따라 순서 초기화
   */
  resetBrandTierListNo = (tierList) => {
    let resetOrderedNo = 0;

    return tierList.map((item) => {
      /**
       *  삭제 상태인 브랜드는 순번을 0으로 하고
       */
      if (item.listStatus === BRAND_TIER_LIST_STATUS.DELETED) {
        return {
          ...item,
          no: 0,
        };
      } else {
        /**
         *  나머지 브랜드의 순서를 초기화한다.
         */
        resetOrderedNo++;

        return {
          ...item,
          no: resetOrderedNo,
        };
      }
    });
  };

  /**
   * 브랜드 수정 상태 변경
   */
  updateTierListStatus = (tierList, tier) => {
    const { brandTierList } = this.props;
    const { originList } = brandTierList;

    /**
     *  티어가 같은 기존 리스트
     */
    const originTierList = originList[tier - 1];

    /**
     *  기존 리스트와 비교
     */
    return tierList.map((item) => {
      let listStatus = item.listStatus;

      /**
       *  기존 브랜드 인덱스
       */
      const originItemIndex = findIndex(originTierList, ['storeId', item.storeId]);

      /**
       *  상태를 초기화하는 브랜드가 변경이전 다른 티어였으면 상태를 바꾸지 않는다.
       */
      if (originItemIndex < 0) {
        return item;
      }

      /**
       *  새롭게 추가된 브랜드는 기존 브랜드와 비교하지 않는다.
       */
      if (item.listStatus === BRAND_TIER_LIST_STATUS.NORMAL || item.listStatus === BRAND_TIER_LIST_STATUS.MODIFIED) {
        /**
         *  기존 브랜드
         */
        const originItem = originTierList[originItemIndex];

        /**
         *  기존 브랜드와 no가 다르면 수정 상태로 판단한다.
         */
        if (item.no !== originItem.no) {
          listStatus = BRAND_TIER_LIST_STATUS.MODIFIED;
        } else {
          /**
           *  아닌 경우 기본 상태이다.
           */
          listStatus = BRAND_TIER_LIST_STATUS.NORMAL;
        }
      }

      return {
        ...item,
        listStatus,
      };
    });
  };

  /**
   * 티어 변경
   */
  changeTierOnBrandTierList = (tier, list) => {
    const { brandTierList, setData } = this.props;
    const { newList } = brandTierList;

    /**
     *  삭제될 브랜드 정보 리스트
     */
    const willBeDeletedList = list.map((item) => {
      if (item) {
        return {
          storeId: item.storeId,
        };
      }
    });

    /**
     *  티어를 변경한 새로운 리스트로 덮어쓴다.
     */
    const updatedList = BRAND_TIER_LIST.map((_, tierIndex) => {
      const tierList = newList[tierIndex];
      /**
       *  기존 티어목록에서 티어와 순서가 같은 브랜드를 삭제하고
       */
      const deletedList = differenceWith(tierList, willBeDeletedList, (tierItem, deletedData) => {
        return tierItem.storeId === deletedData.storeId;
      });

      /**
       *  상태에 따라 순번을 초기화하고
       */
      const resetList = this.resetBrandTierListNo(deletedList);
      /**
       *  나머지 브랜드의 상태를 결정한다.
       */
      const resultList = this.updateTierListStatus(resetList, tierIndex + 1);

      /**
       *  변경할 티어에 브랜드를 추가한다.
       */
      if (tierIndex + 1 === tier) {
        const newTierList = list.map((item, index) => {
          return {
            ...item,
            tier,
            no: resultList.length + index + 1,
            /**
             *  추가하는 브랜드가 추가 상태면 유지하고 아니라면 수정상태로 추가한다.
             */
            listStatus:
              item.listStatus === BRAND_TIER_LIST_STATUS.ADDED
                ? BRAND_TIER_LIST_STATUS.ADDED
                : BRAND_TIER_LIST_STATUS.MODIFIED,
          };
        });
        return [...resultList, ...newTierList];
      } else {
        return resultList;
      }
    });

    /**
     *  새로운 티어 리스트로 덮어쓴다
     */
    setData({
      path: ['brandTierList', 'newList'],
      value: updatedList,
    });

    /**
     *  변경한 티어 패널 닫혀있으면 열어준다.
     */
    setData({
      path: ['brandTierList', 'toggleList', tier - 1],
      value: false,
    });
  };

  /**
   * dnd로 순서변경
   */
  changeNumberOnDragEnd = (result) => {
    const { source, destination, tier } = result;

    if (!source || !destination) return;

    this.changeNumberOnBrandTierList(tier, source.index, destination.index);
  };

  /**
   * input 으로 순서 변경
   */
  changeNumberOnBrandTierList = (tier, sourceIndex, destinationIndex) => {
    const { brandTierList, setData } = this.props;
    const { newList } = brandTierList;

    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = tier - 1;
    /**
     *  선택한 티어의 리스트
     */
    const tierList = newList[tierIndex];

    /**
     *  브랜드 티어 리스트의 순서를 바꾸고
     */
    const reOrderedList = reOrderArray(tierList, sourceIndex, destinationIndex);

    /**
     *  상태에 따라 순번을 초기화하고
     */
    const resetList = this.resetBrandTierListNo(reOrderedList);

    /**
     *  나머지 브랜드의 상태를 결정한다.
     */
    const resultList = this.updateTierListStatus(resetList, tier);

    /**
     *  새로운 브랜드 티어 리스트를 반환한다.
     */
    setData({
      path: ['brandTierList', 'newList', tierIndex],
      value: resultList,
    });
  };

  /**
   * 브랜드 티어목록에서 삭제
   */
  deleteBrandTier = (tier, storeId) => {
    const { brandTierList, setData } = this.props;
    const { newList, selectedList } = brandTierList;

    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = tier - 1;
    /**
     *  선택한 티어의 리스트
     */
    const tierList = newList[tierIndex];
    /**
     *  삭제하려는 브랜드 인덱스
     */
    const brandIndex = findIndex(tierList, ['storeId', storeId]);
    /**
     *  삭제하려는 브랜드 정보
     */
    const brandInfo = tierList[brandIndex];

    /**
     *  삭제한 브랜드 리스트
     */
    let updatedList = [];

    /**
     *  새롭게 추가된 경우 목록에서 삭제한다.
     */
    if (brandInfo.listStatus === BRAND_TIER_LIST_STATUS.ADDED) {
      updatedList = filter(tierList, (item) => item.no !== brandInfo.no);
    } else if (brandInfo.listStatus === BRAND_TIER_LIST_STATUS.DELETED) {
      /**
       *  삭제취소를 하는 경우
       */
      updatedList = tierList.map((item) => {
        let listStatus = item.listStatus;
        if (item.storeId === storeId) listStatus = BRAND_TIER_LIST_STATUS.NORMAL;

        return { ...item, listStatus };
      });
    } else {
      /**
       *  삭제상태로 만드는 경우
       */
      updatedList = tierList.map((item) => {
        let editedNumber = item.no;
        let listStatus = item.listStatus;

        /**
         *  삭제한 브랜드만 삭제 상태로 만들고
         */
        if (item.storeId === storeId) {
          editedNumber = 0;
          listStatus = BRAND_TIER_LIST_STATUS.DELETED;
        }

        return {
          ...item,
          no: editedNumber,
          listStatus,
        };
      });
    }

    /**
     *  상태에 따라 순번을 초기화하고
     */
    const resetList = this.resetBrandTierListNo(updatedList);

    /**
     *  나머지 브랜드의 상태를 결정한다.
     */
    const resultList = this.updateTierListStatus(resetList, tier);

    setData({
      path: ['brandTierList', 'newList', tierIndex],
      value: resultList,
    });

    /**
     *  삭제 시 브랜드 선택 해제
     */
    if (some(selectedList[tierIndex], ['storeId', storeId])) {
      /**
       *  삭제하는 브랜드가 제외된 선택 목록을 만들고
       */
      const excludedSelectedList = filter(selectedList[tierIndex], (item) => item.storeId !== storeId);

      /**
       *  선택 목록으로 덮어쓴다
       */
      setData({
        path: ['brandTierList', 'selectedList', tierIndex],
        value: excludedSelectedList,
      });
    }
  };

  /**
   * ***************************************
   *
   * 티어 셀렉터에서 사용하는 액션들
   *
   * ****************************************
   */

  /**
   * 티어 셀렉터 검색
   */
  searchBrandTierSelectorList = () => {
    const { brandTierSelector, getBrandTierSelectorList } = this.props;
    const { filterOption } = brandTierSelector;
    const { storeName } = filterOption;

    if (storeName && trim(storeName)) {
      getBrandTierSelectorList({
        filterOption: {
          storeName: trim(storeName),
        },
      });
    } else {
      message.error('브랜드명을 입력하세요');
    }
  };

  /**
   * 티어 셀렉터 초기화
   */
  resetBrandTierSelectorList = () => {
    const { getBrandTierSelectorList, setData } = this.props;

    /**
     *  셀렉터 목록 초기화
     */
    getBrandTierSelectorList({
      filterOption: BRAND_TIER_SELECTOR_FILTER_OPTION_MODEL,
    });

    /**
     *  브랜드 셀렉터 선택 티어 값 초기화
     */
    setData({
      path: ['brandTierSelector', 'filterOption'],
      value: BRAND_TIER_SELECTOR_FILTER_OPTION_MODEL,
    });

    /**
     *  브랜드 셀렉터 선택 티어 값 초기화
     */
    setData({
      path: ['brandTierSelector', 'selectedTier'],
      value: null,
    });

    /**
     *  브랜드 셀렉터 선택값 초기화
     */
    setData({
      path: ['brandTierSelector', 'selectedList'],
      value: [],
    });
  };

  /**
   * 이미 티어 리스트에 추가되었는지 중복 체크
   */
  checkIsDuplicateOnTierList = (storeId) => {
    const { brandTierList } = this.props;
    const { newList } = brandTierList;

    /**
     *  이중 배열로 되어있던 걸 1차원 배열로 변환
     */
    const allList = flattenDeep(newList);

    /**
     *  storeId가 같은 요소가 있으면 true
     */
    return some(allList, ['storeId', storeId]);
  };

  /**
   * 셀렉터에서 티어 리스트로 직접 추가
   */
  addBrandTierListItem = (item) => {
    const { brandTierList, brandTierSelector, setData } = this.props;
    const { newList } = brandTierList;
    const { selectedTier, selectedList } = brandTierSelector;

    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = selectedTier - 1;
    /**
     *  선택한 티어의 리스트
     */
    const tierList = newList[tierIndex];

    /**
     *  삭제상태인 브랜드의 수 구하고
     */
    const deletedBrandCount = tierList.filter((item) => item.listStatus === BRAND_TIER_LIST_STATUS.DELETED).length;

    /**
     *  브랜드 티어 리스트에 추가하고
     */
    setData({
      /**
       *  선택한 브랜드 목록에서 가장 마지막에 추가하며
       */
      path: ['brandTierList', 'newList', tierIndex, tierList.length],
      /**
       *  no 를 1 증가시켜서 넣어준다.
       */
      value: {
        ...item,
        tier: selectedTier,
        no: tierList.length - deletedBrandCount + 1,
        listStatus: BRAND_TIER_LIST_STATUS.ADDED,
      },
    });

    /**
     *  selectedList 에서 추가한 브랜드를 제외하고
     */
    const filteredSelectedList = selectedList.filter((selectedItem) => selectedItem.storeId !== item.storeId);

    /**
     *  selectedList 로 덮어쓴다
     */
    setData({
      path: ['brandTierSelector', 'selectedList'],
      value: filteredSelectedList,
    });

    /**
     *  변경한 티어 패널 닫혀있으면 열어준다.
     */
    setData({
      path: ['brandTierList', 'toggleList', selectedTier - 1],
      value: false,
    });

    /**
     *  해당 영역으로 스크롤 이동한다.
     */
    setTimeout(() => this.scrollToBrandElement(selectedTier, tierList.length), 0);
  };

  /**
   * 셀렉터 브랜드 전체 선택
   */
  selectSelectorList = () => {
    const { brandTierList, brandTierSelector, setData } = this.props;
    const { newList } = brandTierList;
    const { list } = brandTierSelector;

    /**
     *  이중 배열로 되어있던 걸 1차원 배열로 변환
     */
    const allList = flattenDeep(newList);

    /**
     *  선택한 브랜드 리스트와 이미 등록된 브랜드 리스트를 비교해서 이미 등록되지 않은 것들만 등록
     */
    const newCheckList = getDifferenceList(list, allList, 'storeId', 'storeId');

    setData({
      path: ['brandTierSelector', 'selectedList'],
      value: newCheckList,
    });
  };

  /**
   * 선택 추가
   */
  addSelectedItemToList = () => {
    const { brandTierList, brandTierSelector, setData } = this.props;
    const { newList } = brandTierList;
    const { selectedList, selectedTier } = brandTierSelector;

    /**
     *  선택한 티어의 리스트 인덱스
     */
    const tierIndex = selectedTier - 1;
    /**
     *  선택한 티어의 리스트
     */
    const tierList = newList[tierIndex];

    /**
     *  삭제상태인 브랜드의 수를 구하고
     */
    const deletedBrandCount = tierList.filter((item) => item.listStatus === BRAND_TIER_LIST_STATUS.DELETED).length;

    /**
     *  선택했던 브랜드 리스트를 더하고
     */
    const addedNewList = concat(tierList, selectedList)
      /**
       *  티어, 순서를 추가한 후에 reducer 에 등록
       */
      .map((item, index) => {
        /**
         *  새로 추가되는 브랜드면 listStatus: added 추가
         */
        if (index > tierList.length - 1) {
          return {
            ...item,
            tier: selectedTier,
            no: index - deletedBrandCount + 1,
            listStatus: BRAND_TIER_LIST_STATUS.ADDED,
          };
        } else {
          return {
            ...item,
            tier: selectedTier,
          };
        }
      });

    setData({
      path: ['brandTierList', 'newList', tierIndex],
      value: addedNewList,
    });

    /**
     *  selectedList 에서 추가한 브랜드를 제외하고
     */
    const filteredSelectedList = getDifferenceList(selectedList, addedNewList, 'storeId', 'storeId');

    /**
     *  selectedList 로 덮어쓴다
     */
    setData({
      path: ['brandTierSelector', 'selectedList'],
      value: filteredSelectedList,
    });

    /**
     *  변경한 티어 패널 닫혀있으면 열어준다.
     */
    setData({
      path: ['brandTierList', 'toggleList', selectedTier - 1],
      value: false,
    });

    /**
     *  해당 영역으로 스크롤 이동한다.
     */
    setTimeout(() => this.scrollToBrandElement(selectedTier, tierList.length), 0);
  };

  render() {
    const { brandTierHeader, brandTierList, brandTierSelector, setData, editBrandTierListRequest } = this.props;

    return (
      <BrandTierWrap
        currentTierList={BRAND_TIER_LIST}
        brandTierHeader={brandTierHeader}
        brandTierList={brandTierList}
        brandTierSelector={brandTierSelector}
        setData={setData}
        multipleTierChange={this.multipleTierChange}
        checkIsModified={this.checkIsModified}
        editBrandTierListRequest={editBrandTierListRequest}
        resetBrandTierInfo={this.resetBrandTierInfo}
        scrollToBrandElement={this.scrollToBrandElement}
        selectBrandTierItem={this.selectBrandTierItem}
        selectBrandTierList={this.selectBrandTierList}
        deselectBrandTierItem={this.deselectBrandTierItem}
        changeTierOnBrandTierList={this.changeTierOnBrandTierList}
        changeNumberOnDragEnd={this.changeNumberOnDragEnd}
        changeNumberOnBrandTierList={this.changeNumberOnBrandTierList}
        deleteBrandTier={this.deleteBrandTier}
        searchBrandTierSelectorList={this.searchBrandTierSelectorList}
        resetBrandTierSelectorList={this.resetBrandTierSelectorList}
        addBrandTierListItem={this.addBrandTierListItem}
        checkIsDuplicateOnTierList={this.checkIsDuplicateOnTierList}
        selectSelectorList={this.selectSelectorList}
        addSelectedItemToList={this.addSelectedItemToList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    brandTierHeader: state.brand.brandTierHeader,
    brandTierList: state.brand.brandTierList,
    brandTierSelector: state.brand.brandTierSelector,
  };
};

const mapDispatchToProps = {
  setData: brandActions.setData,
  getBrandTierInfo: brandActions.getBrandTierInfo,
  getBrandTierSelectorList: brandActions.getBrandTierSelectorList,
  editBrandTierListRequest: brandActions.editBrandTierListRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandTierContainer);
